getRandomPerson = () ->
  peopleArr = ["Steve Jobs", "Bill Gates", "Elon Musk", "Mark Zuckerberg"]
  person = peopleArr[Math.floor(Math.random() * peopleArr.length)];
  return person

addExtraButton = (elName, btnLabel) ->
  className = ""
  for c in $("#div_el_"+elName).attr('class').split(/\s+/)
    if (c.match("^col-sm"))
      className = c

  currentNumber = className.split("-")[2]
  $("#div_el_"+elName).toggleClass className+' col-sm-'+(currentNumber-1)
  newDiv = $ "<div class='col-sm-1'></div>"
  newBtn = $ "<button type='button' class='btn btn-primary btn-sm'>"+btnLabel+"</button>"
  newBtn.appendTo newDiv
  newDiv.insertAfter( $("#div_el_"+elName) );

  return newBtn

handleExit = () ->
  if exampleClicked==0
    runBootStro()

runBootStro = () ->
  options={
  "finishButton": "",
  "onExit": handleExit
  }
  bootstro.start(".bootstro", options);

exampleClicked=0
$ ->
  tools = new Tools()
  tools.showMessages(messages, $("#messages_row"))
  tools.bootstrapifyForm('form')

  if window.location.href.match(/campaign\/[0-9]+$/) or window.location.href.match(/campaign\/[0-9]+\/form5500\/[0-9]+$/) or window.location.href.match(/campaign\/[0-9]+\/crib\/[0-9]+$/) or window.location.href.match(/campaign\/form5500Q/)
    if $("#target_keywords").val().match(/^\+/)
      $("#form_group_target_keywords").hide()

  $("#second_part").attr "style", "margin-top: 0px; margin-bottom: 0px; height: 100px;"

  $("#loading").hide()
  $("#submitCampaign").click () ->
    $("#submitText").hide()
    $("#loading").show()
    $("#submitCampaign").submit()

  targetKeywordsTagEditor = $('#target_keywords').tagEditor();
  $('#zip_codes').tagEditor()

  $("#form_group_zip_codes").hide();

  show_zip_codes = $("#filter_results_by_zip_codes").is(':checked')
  if (show_zip_codes)
    $("#form_group_zip_codes").show();

  $("#filter_results_by_zip_codes").on 'change', ->
    $("#form_group_zip_codes").toggle()

  addExtraButton("zip_codes", "-").click () ->
    for tag in $('#zip_codes').tagEditor('getTags')[0].tags
      $('#zip_codes').tagEditor('removeTag', tag)

  addExtraButton("zip_codes", "+").click () ->
    $('#generateZipCodes').modal('show');


  $("#generateZipCodesOK").click () ->
    zip_code = $("#zip_code").val()
    radius = $("#radius").val()
    callback = (response) ->
      zip_codes = response["zip_codes"].join()
      for zip_code in response["zip_codes"]
        $('#zip_codes').tagEditor('addTag', zip_code)

    $.get '/get_zip_codes_by_radius/'+zip_code+'/'+radius, callback, 'json'

  person = getRandomPerson()

  lastText = ""
  $(".form-control").on "input", ()->
    text = ""
    text = text + $("#greeting").val()
    text = text + "<br/><br/>"
    text = text + $("#introduction_sentence").val() + " " + $("#second_part").val()
    text = text + "<br/></br>"
    text = text + $("#email_signature").val()
    text = text.replace(/(?:\r\n|\r|\n)/g, '<br/>');
    if (lastText!=text)
      $("#preview-text").html text
      lastText = text

  examples = {}
  examples["example01"] = {
    "campaign_name": "campaign for number1 customers",
    "target_keywords": "investment",
    "email_subject":  "Your Investment Plans",
    "greeting": "Hello[ #first_name#],"
    "introduction_sentence": "I am Mr. CEO from ABC Company.",
    "second_part": "We are providing abc product that can leverage your xyz. [As you say on your website \"#1#\",] I believe we can collaborate to achieve you goals.",
    "email_signature": "Best, Mr. CEO",
    "__hide_targetkeywords": false
  }
  examples["example02"] = {
    "campaign_name": "campaign for people searching for a retirement plan",
    "target_keywords": "retirement",
    "email_subject":  "Personal Pension Plans",
    "greeting": "Hello[ #first_name#],"
    "introduction_sentence": "We can help you develop a strategy to convert your 401(K) into a Personal Pension Plan.",
    "second_part": "If you want to  achieve the security of knowing that you cannot outlive your money then we should have that free conversation. [As you say on your website \"#1#\",] I believe we can co-operate. I will call in a few days to ask you some questions that will help determine your best strategy for that goal.",
    "email_signature": "Best, Mr. CEO",
    "__hide_targetkeywords": false,
  }
  examples["example03"] = {
    "campaign_name": "campaign for people searching for a retirement plan",
    "target_keywords": "+ameriprise",
    "email_subject":  "Personal Pension Plans",
    "greeting": "Hello[ #first_name#],"
    "introduction_sentence": "We can help you develop a strategy to convert your 401(K) into a Personal Pension Plan.",
    "second_part": "If you want to  achieve the security of knowing that you cannot outlive your money then we should have that free conversation. I believe we can co-operate. I will call in a few days to ask you some questions that will help determine your best strategy for that goal.",
    "email_signature": "Best, Mr. CEO",
    "__hide_targetkeywords": true
  }
  examples["example04"] = {
    "campaign_name": "form5500",
    "target_keywords": "+form5500",
    "email_subject":  "Your Form5500 renewal date is approaching",
    "greeting": "Hello[ #first_name#],"
    "introduction_sentence": "We are specialized in ...",
    "second_part": "We can decide together which option will ...",
    "email_signature": "Best, Mr. CEO",
    "__hide_targetkeywords": true
  }
  examples["example05"] = {
    "campaign_name": "my first campaign",
    "email_subject":  "Hi[ #first_name#]",
    "greeting": "Hello[ #first_name#],"
    "introduction_sentence": "I'm the Marketing Manager at XYZ Company.",
    "second_part": "Our research on your product shows that we have many mutual synergies.
    I will call you next week to discuss.",
    "email_signature": "Best, Mr. CEO",
    "__hide_targetkeywords": false
  }
  examples["example06"] = {
    "campaign_name": "NJ Crib",
    "target_keywords": "+crib",
    "email_subject":  "Your renewal date is approaching",
    "greeting": "Hello[ #first_name#],"
    "introduction_sentence": "We are specialized in ...",
    "second_part": "We can decide together which option will ...",
    "email_signature": "Best, Mr. CEO",
    "__hide_targetkeywords": true
  }
  $("#div_el_second_part").append $("<mark id='second_part_note'></mark>")

  $(".fillexample").click ->
    $('#target_keywords').tagEditor('destroy');
    example = examples[$(this).attr("id")]
    console.log(example)
    for k,v of example
      if k=="__hide_targetkeywords"
        if v
          $("#form_group_target_keywords").hide()
        else
          $("#form_group_target_keywords").show()
      else
        $(document.getElementById(k)).val(v)
    $('#target_keywords').tagEditor();

    if window.location.href.match(/campaign\/form5500\/[0-9]+$/) or window.location.href.match(/campaign\/form5500Q/)
      $("#form_group_filter_results_by_zip_codes").hide()
      $("#form_group_target_keywords").hide()
      $("#target_keywords").val("+form5500")

    if window.location.href.match(/campaign\/crib\/[0-9]+$/)
      $("#form_group_filter_results_by_zip_codes").hide()
      $("#form_group_target_keywords").hide()
      $("#target_keywords").val("+crib")

    $("#second_part_note").text("This is part of how we help you micro-target your audience with a customized message.
        Ignore the sentence inside the parenthesis for now and focus on writing a closing sentence which comes after it
        (For example, “I believe we have many mutual synergies that will allow us to work together.”)
        When you hit “submit” and proceed to the next page, you will see a sentence highlighted in blue
        which we have extracted from your target customer’s website if it is available for that contact.
        We have done this to further customize your message to the people you are contacting.")
    exampleClicked=1
    bootstro.stop()

  runBootStro()
  if window.location.href.match(/campaign\/keywords\/.*$/)
    $("#example05").trigger("click")
